<!-- @format -->

<div *transloco="let t">
  @if (!hideTitle) {
    <h3>{{ t("UNAUTHORIZED.TITLE") }}</h3>
  }
  {{ t("UNAUTHORIZED.MESSAGE") }}
</div>
